import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Segment, Card, Header, Grid, Label, Button, Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getVocabulary } from '@plone/volto/actions';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCalendar, faClock } from '@fortawesome/free-regular-svg-icons';
import { keys, isEmpty, map } from 'lodash';
import { formatDate, formatTime } from '../../../helpers'
import { Icon } from '../../';


const EventsListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';

	const vocabularySubjects = 'plone.app.vocabularies.Keywords';
	const dispatch = useDispatch();
	const itemsSubjects = useSelector(
		(state) =>
			state.vocabularies[vocabularySubjects] && state.vocabularies[vocabularySubjects].items
				? [...state.vocabularies[vocabularySubjects].items]
				: [],
		shallowEqual,
	);

	useEffect(() => {
		dispatch(getVocabulary({ vocabNameOrURL: vocabularySubjects }));
	}, [dispatch]);

	const getEventSubject = function (subject) {
		if (!itemsSubjects) {
			return subject
		}
		for (let item of itemsSubjects) {
			if (item.value === subject) return item.label
		}
		return subject
	}

	const getEventDate = function (start, end, open_end) {
		const optionsFullTime = { year: 'numeric', month: '2-digit', day: '2-digit' };

		if (open_end) {
			return (
				<time dateTime={start} className='d-flex align-items-center'>
				<FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
				<span suppressHydrationWarning>{formatDate(start, optionsFullTime)}</span>
				</time>
			);
		}

		const startDay = formatDate(start);
		const endDay = formatDate(end);

		if (startDay === endDay) {
			return (
				<time dateTime={start} className='d-flex align-items-center'>
				<FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
				<span suppressHydrationWarning>{formatDate(start, optionsFullTime)}</span>
				</time>
			);
		}

		return (
			<>
				<time suppressHydrationWarning dateTime={start} className='d-flex align-items-center mb-1'>
				<span className="eventsItem__date__day">
					<FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
					<span suppressHydrationWarning>{formatDate(start, optionsFullTime)}</span>
				</span>
				</time >
				<time suppressHydrationWarning dateTime={end} className='d-flex align-items-center'>
				<span className="eventsItem__date__day">
					<FontAwesomeIcon className="eventsItem__icon me-2" icon={faCalendar} />
					<span suppressHydrationWarning>{formatDate(end, optionsFullTime)}</span>
				</span>
				</time>
			</>
		);
	};


	return ( 
		<Container>
			{blockTitle && <h3 className="eventListing__title">{blockTitle}</h3>}			
			<Grid columns={12} as="ul" className='eventsList ny-0 list-unstyled'>
				{items.map((item) => (
					<Grid.Column mobile={12} tablet={6} computer={4} widescreen={4} largeScreen={4} key={item['@id']} as='li' >
						<Card fluid as="article" className="eventsItem position-relative">
							{item.image_field && (
								<div className="eventsItem__figure">
									<PreviewImage
										item={item}
										alt={item.image_caption ? item.image_caption : ''}
										className="eventsItem__img m-0 image"
										sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, (max-width: 1599px) 33.33vw, 25vw"
									/>
								</div>
							)}
							<Card.Content className='eventsItem__text'  >
								{item.Subject?.length > 0 && ( 
									<Card.Meta className="eventsItem__meta mb-3">
										{map(item.Subject.slice(0, 1), (item, index) => (
											<span key={item} className="newsItem__subject__item" >{getEventSubject(item)}</span>
										))}
									</Card.Meta>
								)}
								<Card.Header as="h3" className="eventsItem__title">
									<UniversalLink href={flattenToAppURL(item['@id'])} className="eventsItem__link stretched-link">{item.title}</UniversalLink>
								</Card.Header>

								<ul className="list-unstyled mt-0 d-flex flex-column gap-3 mb-3">
									<li className='mb-0'>
										<div className="eventsItem__date">{getEventDate(item.start, item.end, item.open_end)}</div>
									</li>
									{!item.whole_day && (
									<li className='d-flex align-items-center mb-0'>
										<FontAwesomeIcon className='eventsItem__icon me-2 ' icon={faClock} />
										<span suppressHydrationWarning>{formatTime(item.start)}</span>
									</li>
									)}
									{item.location && (
									<li className=' align-items-center d-flex mb-0'>
										<Icon name='location-outline' className='eventsItem__icon me-2' /> {item.location}
									</li>
									)}
								</ul>
								<div className="text-end mt-auto">
									<FontAwesomeIcon icon={faArrowRight} />
								</div>

							</Card.Content>
						</Card>
					</Grid.Column>
				))}
			</Grid>

			{link &&
				<p className="readMoreItem">
					<UniversalLink href={link} className="readMoreItem__btn ui button primary">{linkTitle}</UniversalLink>
				</p>
			}

		</Container>
	);
}

EventsListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default EventsListing;
